















































































































































import { Vue, Component } from 'vue-property-decorator';
import {
  Unit, Settings, User, UserApi, UnitsApi, Sector, Market, UnitFacility, EventNew,
} from '@compassdigital/foodworks.ts.sdk';
import PageTitle from '@/components/PageTitle/index.vue';
import TabbedNavigation from '@/components/TabbedNavigation/index.vue';
import UnitContactDetail from '@/components/Form/Unit/UnitContactDetail/index.vue';
import ScheduleSetting from '@/components/Form/ScheduleSetting/index.vue';
import FacilityTab from '@/components/Form/Unit/FacilityTab/index.vue';
import Schedule from '@/components/Form/ScheduleSetting/Schedule/index.vue';
import SelectionDropdown from '@/components/Form/SelectionDropdown/index.vue';
import UnitsUtil from '@/util/UnitUtil';
import SystemModule from '@/store/modules/system';
import MarketUtil from '@/util/MarketUtil';
import Format from '@/util/Format';
import ToastModule from '@/store/modules/toast';
import AppModule from '@/store/modules/app';
import UserModule from '@/store/modules/user';
import { IMarketScoutInfo } from '@/interface/marketInfo';
import NonWorkingDays from '@/components/Form/NonWorkingDays/index.vue';
import StandardCard from '@/components/Card/StandardCard/index.vue';
import DeleteProfile from '@/components/Modal/DeleteProfile/index.vue';
import AccountActivation from '@/components/AccountActivation/index.vue';
import Service from '@/util/ServiceUtil';
import FlagUtil from '@/util/FlagUtil';
import { IUnitUserInfo, IUnitProfile } from '@/interface/unitInfo';
import { IFwManagerInfo } from '@/interface/userTableInfo';


@Component({
  components: {
    PageTitle,
    TabbedNavigation,
    UnitContactDetail,
    ScheduleSetting,
    Schedule,
    SelectionDropdown,
    NonWorkingDays,
    StandardCard,
    DeleteProfile,
    AccountActivation,
    FacilityTab,
  },
})
export default class ScheduleSettings extends Vue {
  public unitDetails: any = '';

  public marketItems: Market [] = [];

  private scoutItems: User [] = [];

  private sectorItems: Sector [] = [];

  public unitStatus: string = '';

  public loading: boolean = false;

  public saving: boolean = false;

  private errors: string = 'active';

  private editValue: boolean = false;

  private menuId: string = 'schedule';

  private unitID: string = '';

  private marketID: string = '';

  private dialog: boolean = false;

  private dialogLoading: boolean = false;

  private unitProfile: IUnitProfile = {
    deleteProfile: '',
    profileName: '',
    saving: false,
  }

  private activationLoader: boolean = false;

  private unitUserInfo: IUnitUserInfo = {
    unitManagerEmail: '',
    is: '',
  };

  private scoutUserInfo: IFwManagerInfo = {
    scoutUserEmail: '',
    is: '',
  }


  public async mounted() {
    await this.getMarkets();
    await this.getUnitDetails();
    // set initial menuID based on flags
    if (!this.isSchedulingEnabled || this.unitUserRole) {
      this.menuId = 'nonWorkingDays';
    }
    if (!this.isSchedulingEnabled || this.partnerUserRole) {
      this.menuId = 'facilityDetails';
    }
  }

  public async getMarkets() {
    const { markets }: any = SystemModule;
    const items = MarketUtil.getMappedMarkets(markets);
    (this.marketItems) = Format.sortedArray(items);

    const { sectors }: any = SystemModule;
    const sectorValues = MarketUtil.getMappedMarkets(sectors);
    (this.sectorItems) = Format.sortedArray(sectorValues);
  }

  public onChangeTab(id: string) {
    this.menuId = id;
  }

  public async getUnitDetails() {
    try {
      const { id } = this.$route.params;
      this.unitID = id;
      const scoutApi = new UserApi(AppModule.apiConfig);
      const users = await scoutApi.getUsers();
      ((this.scoutItems) as any) = UnitsUtil.scoutListFormatted(users.data);
      const api = new UnitsApi(AppModule.apiConfig);
      const unitUser = await api.getUnitById(id);
      const unitUserData = unitUser.data;
      const { managerUserId, scoutUserId } = unitUserData;
      this.getUnitUserInfo(managerUserId as string, scoutUserId as string);
      this.unitDetails = await UnitsUtil.mappedDetailsUnit(
        unitUser.data,
        this.marketItems as any,
        this.scoutItems as any,
        this.sectorItems as any,
      );
      this.unitProfile.profileName = this.unitDetails.name;
      const { marketId } = this.unitDetails;
      if (this.unitDetails) {
        this.marketID = marketId;
        this.unitStatus = this.unitDetails.active ? 'active' : 'inactive';
      }
    } catch (error) {
      console.log('err', error.response.data);
    }
  }

  public async getUnitUserInfo(managerUserId: string, scoutUserID: string) {
    const userApi = new UserApi(AppModule.apiConfig);
    const users = await Promise.all(
      [(userApi.getUser(managerUserId)), (userApi.getUser(scoutUserID))],
    );
    const user = !users || users.map((response) => response.data);
    if (user) {
      const UnitManagerUser = user[0];
      const scoutUser = user[1];
      const { email, is } = UnitManagerUser;
      this.unitUserInfo.is = is;
      this.unitUserInfo.unitManagerEmail = email as string;
      this.scoutUserInfo.scoutUserEmail = scoutUser.email as string;
      this.scoutUserInfo.is = scoutUser.is;
    }
    return null;
  }

  public async onUpdateStatus(status: string) {
    try {
      this.loading = true;
      if (AppModule.isLoggedIn && AppModule.accessToken) {
        try {
          const { id } = this.$route.params;
          const state = status === 'active';
          const userState: any = {
            active: state,
          };
          const api = new UnitsApi(AppModule.apiConfig);
          const unitState: any = await api.patchUnitById(id, userState);
          if (unitState.status === 200) {
            ToastModule.setToast({
              message: `${unitState.data.name} has been changed successfully`,
              timeout: 5000,
            });
          }
        } catch (err) {
          throw err;
        }
      }
    } catch (err) {
      if (err.error) {
        this.errors = err.error;
      }
    }
    this.loading = false;
  }

  get onBoardingPartnerRole() {
    if (UserModule.currentUser && UserModule.currentRole === 'partner_owner') {
      return UserModule.currentUser.id;
    }
    return '';
  }

  public async onEditButton(edit: boolean) {
    this.editValue = edit;
  }

  get adminUser() {
    if (UserModule.currentRole === 'fw_admin'
    || UserModule.currentRole === 'fw_manager'
    ) {
      return UserModule.currentRole;
    }
    return null;
  }

  checkFlag(flag?: string) {
    if (!flag) return true;
    return FlagUtil.hasFeature(flag);
  }

  get isSchedulingEnabled() {
    if (!FlagUtil.hasFeature('unit.scheduleSettings')) {
      this.menuId = 'nonWorkingDays';
      return false;
    }
    if (FlagUtil.getFlags().market.scheduler_disabled.includes(this.marketID)) {
      this.menuId = 'nonWorkingDays';
      return false;
    }

    const enabled = FlagUtil.getFlags().market.scheduler_enabled;
    if (enabled && enabled.includes(this.marketID)) {
      return true;
    }
    // check market here
    this.menuId = 'nonWorkingDays';
    return false;
  }

  public openDialog() {
    this.dialog = true;
  }

  public closeDialog() {
    this.dialog = false;
    this.unitProfile.deleteProfile = '';
  }

  public async onUnitsProfileDelete() {
    try {
      this.unitProfile.saving = true;
      const api = new UnitsApi(AppModule.apiConfig);
      const user = await api.deleteUnit(this.unitID as string);
      if (user.status === 200) {
        this.unitProfile.deleteProfile = '';
        ToastModule.setToast({
          message: `${this.unitProfile.profileName} has been deleted`,
          timeout: 5000,
        });
        this.$router.push('/units');
      }
    } catch (err) {
      const { error } = err.response.data;
      ToastModule.setToast({
        message: error.message,
        timeout: 5000,
      });
    }
    this.unitProfile.saving = false;
  }

  public get approverStatus() {
    const userStatus = Service.approverUser();
    if (userStatus) {
      return true;
    }
    return false;
  }

  // common pening email account activation
  public async sendInvitation(userEmail: string, userProfile: string) {
    if (userProfile === 'unitmanager') {
      this.activationLoader = true;
    }
    if (userProfile === 'fwmanager') {
      this.saving = true;
    }
    const user: any = await Service.sendInvitation(userEmail);
    if (user.status === 200) {
      ToastModule.setToast({
        message: 'Sign up invitation has been sent',
        timeout: 5000,
      });
    } else {
      ToastModule.setToast({
        message: user.errorMessage,
        timeout: 5000,
      });
    }
    if (userProfile === 'unitmanager') {
      this.activationLoader = false;
    }
    this.saving = false;
  }

  get partnerUserRole() {
    if (UserModule.currentRole === 'partner_owner') {
      return UserModule.currentRole;
    }
    return null;
  }

  get unitUserRole() {
    if (UserModule.currentRole === 'unit_manager') {
      return UserModule.currentRole;
    }
    return null;
  }
}
